import { render, staticRenderFns } from "./ComCrumb.vue?vue&type=template&id=2d27d53d&scoped=true"
import script from "./ComCrumb.vue?vue&type=script&lang=js"
export * from "./ComCrumb.vue?vue&type=script&lang=js"
import style0 from "./ComCrumb.vue?vue&type=style&index=0&id=2d27d53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27d53d",
  null
  
)

export default component.exports